import React, { useState, useEffect } from "react";
import moment from "moment";
import { LocalStorageService, toAbsoluteUrl } from "../../services";
import Dialog from "@mui/material/Dialog";
import Button from "../button/button";
import SwitchButton from "../switch/switch";
import Input from "../input/input";
import Calendar from "react-calendar";
import ErrorMessage from "../message/message";
import Slide from "@mui/material/Slide";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSelector, connect } from "react-redux";
import { AiOutlineLink, AiOutlineEye } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { RiShutDownLine } from "react-icons/ri";
import { useNavigate } from "react-router";
import ROUTES from "../../free/constants/routes";
import { getApi } from "../../services/helpers/apiCall";
import authHeader from "../../services/auth/auth-header";
// get step data from redux main state
const data = (state) => state.dashboard;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const CardComponent = (props) => {
  let campaignData = useSelector(data);
  let navigate = useNavigate();
  let { message, loadWhileUpdate } = campaignData;
  let {
    name,
    startDate,
    endDate,
    completed,
    total,
    id,
    state,
    apptitude,
    behaviour,
    cognitiveAbilities,
    url,
  } = props.campaign;

  let { userType, maxDate } = props;

  const [open, setopen] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  const [launchDate, setLaunchDate] = useState(new Date(startDate));
  const [handleLaunchCalendar, setLaunchCalendar] = useState(false);
  const [closingDate, setClosingDate] = useState(new Date(endDate));
  const [handleClosingCalendar, setClosingCalendar] = useState(false);
  const [gameLinkModal, setGameLinkModal] = useState(false);
  // error handler
  const [dateError, setDateError] = useState(false);
  const [dateMessage, setMessage] = useState("");
  const [active, setActive] = useState(state === "active" ? true : false);
  const [campaignType, setCampaignType] = useState();

  const onAgreeGameModal = () => {
    setGameLinkModal(false);
  };

  const onAgree = () => {
    if (state !== "active" && launchDate > closingDate) {
      setDateError(true);
      setMessage("Closing date should be greater than Launch Date!");
      setTimeout(() => {
        setDateError(false);
      }, 2000);
    } else {
      let data = {
        launchDate: startDate,
        closingDate: endDate,
        state: active ? "active" : "completed",
        id,
      };
      props.updateCampaignDate(data);
    }
  };

  const onDisAgree = () => {
    setLaunchDate(new Date(startDate));
    setClosingDate(new Date(closingDate));
    setActive(state === "active" ? true : false);
    setopen(false);
  };

  const handeleViewCandidates = () => {
    let data = props.campaign;
    let endDate = new Date();
    let updatedDate = moment(endDate).add(1, "days");
    let formattedDate = updatedDate.format("YYYY-MM-DD");
    let singleCampaignData = {
      campaignId: data.id,
      label: data.name,
      state: data.state,
      value: data.name,
      createdAt: data.createdAt,
      startDate: data.start_date,
      endDate: formattedDate,
      campaignEmail: data.campaignEmail,
      emailSubject: data.emailSubject,
      emailTemplate: data.emailTemplate,
    };

    LocalStorageService.setObject("campaign", [singleCampaignData]);
    // LocalStorageService.setObject("path", "leaderBoard");
    navigate(`${ROUTES.REPORT}`);
  };

  const handeleSentInvite = () => {
    let data = props.campaign;
    navigate(`${ROUTES.INVITE}`, {
      state: {
        campaignId: data.id,
        url: data.url,
      },
    });
  };

  let getCampaignType = async () => {
    if (id) {
      const { data } = await getApi({
        url: `/auth/campaign/config/${id}`,
        data: {},
        config: {
          headers: authHeader(),
        },
      });
      const resp = data.components[0]?.saas;
      setCampaignType(resp.type);
    }
  };

  useEffect(() => {
    getCampaignType();
  }, []);

  return (
    <>
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description2"
        >
          <div className="px-10">
            <div className="pt-10">
              {/* active tab Launch Date start */}
              <div>
                {active ? (
                  <p className="my-6">
                    Your assessment game is currently active. If you want to
                    deactivate your assessment game, please switch the button
                    below.
                  </p>
                ) : (
                  <p className="my-6">
                    Your assessment game is currently inactive. If you want to
                    activate it, please switch the button below.
                  </p>
                )}

                <SwitchButton
                  label={active ? "Active" : "Completed"}
                  checked={active}
                  onChange={() => setActive(!active)}
                />
              </div>
              {active ? (
                <div className="mt-6 flex 2xl:flex-row xl:flex-row lg:flex-row flex-col items-start">
                  <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-11/12">
                    <div
                    // onClick={() => {
                    //   setLaunchCalendar(true);
                    //   setClosingCalendar(false);
                    // }}
                    >
                      <Input
                        disabled={true}
                        label="Activation Date"
                        value={
                          launchDate
                            ? moment
                                .utc(launchDate)
                                .local()
                                .format("YYYY-MM-DD")
                            : ""
                        }
                        placeholder="yyyy-mm-dd"
                        customStyle={"mb-7 "}
                        onChange={() => {}}
                      />
                    </div>
                    <div
                    // onClick={() => {
                    //   setClosingCalendar(true);
                    //   setLaunchCalendar(false);
                    // }}
                    >
                      <Input
                        disabled={true}
                        label="Closing Date"
                        customStyle={"mb-7 w-full"}
                        value={
                          closingDate
                            ? moment
                                .utc(closingDate)
                                .local()
                                .format("YYYY-MM-DD")
                            : ""
                        }
                        placeholder="yyyy-mm-dd"
                        onChange={() => {}}
                      />
                    </div>
                  </div>
                  <div className="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-11/12 2xl:ml-4 xl:ml-4 lg:ml-4 md:ml-4 mt-6 ">
                    <div>
                      {handleLaunchCalendar ? (
                        <Calendar
                          calendarType="US"
                          onChange={(value, event) => setLaunchDate(value)}
                          value={launchDate}
                          maxDate={new Date(maxDate)}
                          minDate={new Date()}
                        />
                      ) : null}
                    </div>
                    <div>
                      {handleClosingCalendar ? (
                        <Calendar
                          calendarType="US"
                          onChange={(value, event) => setClosingDate(value)}
                          value={closingDate}
                          maxDate={new Date(maxDate)}
                          minDate={new Date()}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}

              {dateError ? (
                <ErrorMessage
                  customStyle="w-max items-center mx-auto 2xl:px-20 xl:px-20 lg:px-20 px-4  my-2 flex  justify-center font-medium"
                  text={message ? message : dateMessage}
                />
              ) : null}

              {/* active tab Launch Date end */}
            </div>
            <div className="flex flex-row justify-between mt-6 pb-10">
              <Button
                customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12]  text-[white]"
                onClick={onDisAgree}
                name="Back"
              />
              <Button
                customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12] text-[white]"
                onClick={onAgree}
                name={loadWhileUpdate ? "Loading" : "Confirm"}
              />
            </div>
          </div>
        </Dialog>
        <Dialog
          open={gameLinkModal}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="px-10">
            {userType === "free" ? (
              <div className="pt-10">
                <div>
                  <div className="mt-5">
                    <div className="relative">
                      <h5>
                        Company branded game URL is not available in FREE Plan
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="py-4 flex flex-row justify-center mt-12">
                  <Button
                    customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12] text-[white]"
                    onClick={onAgreeGameModal}
                    name="Back"
                  />
                </div>
              </div>
            ) : (
              <div className="pt-10">
                <div>
                  <h3 className="text-[#252B42]">
                    Game URL has been activated.
                  </h3>

                  <div className="mt-5">
                    <div className="relative">
                      <input
                        disabled={true}
                        type="text"
                        value={
                          campaignType === "free"
                            ? `https://free.thetalent.games/${url}/index.html`
                            : "https://" + url + ".thetalent.games"
                        }
                        onChange={() => {}}
                        className="h-12 appearance-none  w-full text-xs border px-2 rounded-md z-0 shadow outline-none"
                        placeholder=""
                      />
                      <div className="absolute top-0  right-0">
                        <CopyToClipboard
                          text={
                            campaignType === "free"
                              ? `https://free.thetalent.games/${url}/index.html`
                              : "https://" + url + ".thetalent.games"
                          }
                          onCopy={() => {
                            setCopied(true);
                            setTimeout(() => {
                              setCopied(false);
                            }, 1500);
                          }}
                        >
                          <button className="h-12  px-8 text-black  bg-[#FEBB12] hover:bg-[#FEBB12]">
                            {copied ? "Copied" : "Copy"}
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-4 flex flex-row justify-between mt-12">
                  <div></div>
                  {/* <Button
                    customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12]  text-[white]"
                    onClick={onDisAgreeGameModal}
                    name="Back"
                  /> */}
                  <Button
                    customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12] text-[white]"
                    onClick={onAgreeGameModal}
                    name="Back"
                  />
                </div>
              </div>
            )}
          </div>
        </Dialog>
      </div>
      <div
        className={`w-[25rem] rounded overflow-hidden p-2 m-[1rem] shadow-md`}
      >
        <img
          className={`w-full rounded-tl-md rounded-tr-md ${
            active ? "opacity-90" : "opacity-70"
          }`}
          src={toAbsoluteUrl(`/media/dashboard/cardcover.jpg`)}
          alt="Sunset in the mountains"
        />
        <div
          className={`px-4 py-2 rounded-bl-md rounded-br-md  ${
            state === "active"
              ? "bg-[#007e8c] text-white"
              : "bg-[#727272] text-white"
          }`}
        >
          <div className="text-xl font-semibold mb-1">{name}</div>
          <div className="dataContent flex justify-between text-sm text-[7px]">
            <ul>
              <li>
                <span
                  className={`text-xs ${
                    state === "active"
                      ? "text-[#FFD700]"
                      : "bg-[#727272] text-white"
                  }`}
                >
                  Launch Date:{" "}
                </span>
                <span className=" text-xs">
                  {" "}
                  {moment.utc(startDate).local().format("YYYY-MM-DD")}
                </span>
              </li>
              <li>
                <span
                  className={` text-xs ${
                    state === "active"
                      ? "text-[#FFD700]"
                      : "bg-[#727272] text-white"
                  }`}
                >
                  Closing Date:
                </span>
                <span className=" text-xs">
                  {" "}
                  {moment.utc(endDate).local().format("YYYY-MM-DD")}
                </span>
              </li>
            </ul>
            <ul>
              <li>
                <span
                  className={` text-xs ${
                    state === "active"
                      ? "text-[#FFD700]"
                      : "bg-[#727272] text-white"
                  }`}
                >
                  Total Registrations:
                </span>
                <span className="text-xs"> {total}</span>
              </li>
              <li>
                <span
                  className={`text-xs ${
                    state === "active"
                      ? "text-[#FFD700]"
                      : "bg-[#727272] text-white"
                  }`}
                >
                  Games Played:
                </span>
                <span className="text-xs"> {completed}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="assement rounded-md mx-1 my-5 uppercase bg-[#FFD700]   text-lg text-[#007e8c] font-semibold text-center h-[2.5rem] flex justify-center items-center">
          {campaignType}
        </div>
        <div className="assement mx-1 my-5 text-lg text-[#555555] h-[2rem]">
          {behaviour || cognitiveAbilities || apptitude === "0"
            ? "Assessments Selected:"
            : null}
        </div>
        <div className="flex justify-around items-center">
          {behaviour > 0 ? (
            <div className="flex flex-col w-[30%] items-center justify-center">
              <img
                className="w-12 h-12"
                src={toAbsoluteUrl(
                  `/media/dashboard/${
                    state === "active" ? "competency.png" : "competencyGrey.png"
                  }`
                )}
                alt="Sunset in the mountains"
              />
              <p
                className={`${
                  state === "active" ? "text-[#007E8C]" : "text-[#727272]"
                }  text-sm text-center `}
              >
                Competency Assessments
              </p>
            </div>
          ) : null}
          {cognitiveAbilities > 0 ? (
            <div className="flex flex-col w-[30%] items-center justify-center">
              <img
                className="w-12 h-12"
                src={toAbsoluteUrl(
                  `/media/dashboard/${
                    state === "active" ? "congnetive.png" : "cognetiveGrey.png"
                  }`
                )}
                alt="Sunset in the mountains"
              />
              <p
                className={`${
                  state === "active" ? "text-[#007E8C]" : "text-[#727272]"
                }  text-sm text-center`}
              >
                Cognitive Assessments
              </p>
            </div>
          ) : null}

          {apptitude > 0 ? (
            <div className="flex flex-col w-[30%] items-center justify-center">
              <img
                className="w-12 h-12"
                src={toAbsoluteUrl(
                  `/media/dashboard/${
                    state === "active" ? "apptitude.png" : "apptitudeGrey.png"
                  }`
                )}
                alt="Sunset in the mountains"
              />
              <p
                className={`${
                  state === "active" ? "text-[#007E8C]" : "text-[#727272]"
                }  text-sm text-center`}
              >
                Aptitude Assessments
              </p>
            </div>
          ) : null}
        </div>

        <div className="px-2 pb-5 flex  mt-4  justify-between  bottom-0 ">
          <button
            className="text-center"
            onClick={() => {
              setopen(true);
            }}
          >
            <RiShutDownLine
              className={`m-3 w-9 h-9 rounded-full ${
                state === "active"
                  ? "bg-[#FFD700] text-[#007E8C]"
                  : "bg-[#E9E9E9]"
              } p-2`}
            />
            <p
              className={`m-[-0.7rem] ${
                state === "active" ? "text-[#007E8C]" : "text-[#727272]"
              }  text-sm text-[10px] font-semibold`}
            >
              {state === "active" ? "Deactivate" : "Activate"}
            </p>
          </button>
          <button
            className=" flex flex-col text-center justify-center items-center "
            onClick={async () => {
              await getCampaignType();
              setGameLinkModal(true);
            }}
          >
            <AiOutlineLink
              className={`m-3 w-9 h-9 rounded-full ${
                state === "active"
                  ? "bg-[#FFD700] text-[#007E8C]"
                  : "bg-[#E9E9E9]"
              } p-2`}
            />
            <p
              className={`m-[-0.7rem] ${
                state === "active" ? "text-[#007E8C]" : "text-[#727272]"
              }  text-sm text-[10px] font-semibold`}
            >
              Game Link
            </p>
          </button>
          <button
            className=" flex flex-col text-center justify-center items-center "
            onClick={() => handeleViewCandidates()}
          >
            <AiOutlineEye
              className={`m-3 w-9 h-9 rounded-full ${
                state === "active"
                  ? "bg-[#FFD700] text-[#007E8C]"
                  : "bg-[#E9E9E9]"
              } p-2`}
            />

            <p
              className={`m-[-0.7rem] ${
                state === "active" ? "text-[#007E8C]" : "text-[#727272]"
              }  text-sm text-[10px] font-semibold`}
            >
              View Candidates
            </p>
          </button>
          <button
            onClick={() => handeleSentInvite()}
            className=" flex flex-col text-center justify-center items-center "
          >
            <BiUserPlus
              className={`m-3 w-9 h-9 rounded-full ${
                state === "active"
                  ? "bg-[#FFD700] text-[#007E8C]"
                  : "bg-[#E9E9E9]"
              } p-2 `}
            />

            <p
              className={`m-[-0.7rem] ${
                state === "active" ? "text-[#007E8C]" : "text-[#727272]"
              }  text-sm text-[10px] font-semibold`}
            >
              Send Invites
            </p>
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, null)(CardComponent);
